














































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { APICarrier } from '@/models/api/carrier.model'
import { APIProvider } from '@/models/api/provider.model'
import Subscriptions from './Subscriptions.vue'
import SubscriptionHistory from './SubscriptionHistory.vue'
import Presubscriptions from './Presubscriptions.vue'
import Blacklist from './Blacklist.vue'
import Messages from './Messages.vue'
import Notification from './Notification.vue'
import { checkPermissions } from '@/directives/permissionDirective'

@Component({
    components: {
        Subscriptions,
        SubscriptionHistory,
        Presubscriptions,
        Blacklist,
        Messages,
        Notification
    }
})
export default class Monitor extends Vue {
    loading = true

    confirmDialogTrigger = false
    confirmDialogData = null

    showCarriersSelect = false
    showProviderSelect = true

    actualTab = 0

    /** Persisted so an agent keeps their preferred tab set between searches. */
    includeAllProviders = false

    legend = [
        {
            state: 'active',
            color: '#0ba048',
            title: 'Green',
            description: 'The line holds an active subscription with this provider.'
        },
        {
            state: 'cancelled',
            color: '#4D4D4D',
            title: 'Grey',
            description: 'Every subscription with this provider is cancelled.'
        },
        {
            state: 'none',
            color: '#B41322',
            title: 'Red',
            description: 'The line never subscribed with this provider.'
        }
    ]

    bigLoadingState = 0
    maxLoadState = 5
    alreadySearch = false
    notFoundProviderFlag = false

    disableCarriers = false

    carriers: object[] = []
    providers: object[] = []

    /** Switching carrier refetches the list, which is not instant. */
    loadingProviders = false
    formData: {msisdn: string; provider: number[]; carrier: number|null} = {
        msisdn: '',
        provider: [],
        carrier: null
    }

    formValid = false
    formRules = {
        msisdn: [
            (v: string) => (!!v && v.length > 0) || 'Field is required'
        ],
        carrier: [
            (v: string) => (!!v) || 'Field is required'
        ]
    }

    loadTriggers = {
        subscription: false,
        subscriptionHistory: false,
        presubscription: false,
        blacklist: false,
        messages: false,
        notification: false
    }

    tabs: {
        providerName: string;
        providerId: number|null;
        onlyBlacklist: boolean;
        state: 'active'|'cancelled'|'none';
    }[] = []

    checkPermision (permission: string) {
        return !!checkPermissions(permission)
    }

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    @Watch('$route.query', { deep: true })
    async onQueryChange () {
        if (!this.formData.carrier) return
        this.notFoundProviderFlag = false

        if (this.formData.msisdn !== '') await this.getMonitorProviders()
        this.startBigLoad()
    }

    @Watch('formData.carrier')
    async onCarrierChange () {
        this.formData.provider = []
        await this.getProviders()

        // Providers belong to a carrier, so switching carrier empties the
        // selection. With the checkbox left on, tick the new carrier's list
        // instead of leaving it claiming a selection it no longer has.
        if (this.includeAllProviders) this.selectAllProviders()
    }

    /**
     * Scoped per user so two agents sharing a machine keep their own
     * preference. Returns null while the session is not resolved yet, in which
     * case nothing is read or written.
     */
    get includeAllProvidersKey (): string|null {
        const userId = this.$store.state.AuthStore?.auth?.user?.userId
        return userId ? `monitor.includeAllProviders.${userId}` : null
    }

    /**
     * A failure to read it (private mode, blocked site data) throws, and must
     * not stop the screen from loading.
     */
    restoreIncludeAllProviders () {
        const key = this.includeAllProvidersKey
        if (!key) return

        try {
            this.includeAllProviders = localStorage.getItem(key) === 'true'
        } catch (error) {
            this.includeAllProviders = false
        }
    }

    /**
     * Driven by a watcher rather than @change: Vuetify's Rippleable mixin
     * spreads the parent's listeners onto the checkbox ripple
     * (`Object.assign({ click: this.onChange }, this.$listeners)`), so an
     * explicit @change ends up bound alongside the one v-model already
     * registers for the same event. Watching the value keeps a single path
     * and only reacts when it actually changes.
     */
    @Watch('includeAllProviders')
    onIncludeAllProvidersChange (value: boolean) {
        const key = this.includeAllProvidersKey
        if (key) {
            try {
                localStorage.setItem(key, String(!!value))
            } catch (error) {
                // Preference will not persist; the current search still works.
            }
        }

        // Ticking it selects every provider in the filter, unticking clears
        // them. Nothing else happens here: the tabs change when the search
        // runs, because the backend only returns providers with no
        // subscription when an explicit provider filter is sent.
        if (value) this.selectAllProviders()
        else this.formData.provider = []
    }

    /** `providers` is declared as object[], so narrow it to read the ids. */
    selectAllProviders () {
        this.formData.provider = (this.providers as { value: number }[]).map(p => p.value)
    }

    async mounted () {
        if (this.$route.params.msisdn) {
            this.alreadySearch = true
            this.formData.msisdn = this.$route.params.msisdn
        }

        this.$store.dispatch('getUserLogued')
            .then(async () => {
                if (this.userData !== null) {
                    // Needs the session, so it runs here rather than on mount.
                    this.restoreIncludeAllProviders()

                    const user = JSON.parse(JSON.stringify(this.userData))

                    if (!user.carrierId) {
                        await this.getCarriers()

                        this.showCarriersSelect = true
                        if (this.$route.query.carrier) this.formData.carrier = parseInt(this.$route.query.carrier.toString())

                        if (this.formData.carrier) await this.getProviders()
                        if (this.carriers.length === 1) {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            this.formData.carrier = (this.carriers[0] as any).value
                            this.showCarriersSelect = false
                        }

                        if (this.formData.msisdn && this.formData.carrier) await this.getMonitorProviders()
                        this.loading = false
                    } else {
                        if (this.$route.query.carrier !== user.carrierId.carrierId) {
                            const routeQuery = { ...this.$route.query }
                            routeQuery.carrier = user.carrierId.carrierId
                            this.formData.carrier = user.carrierId.carrierId

                            await this.getProviders()

                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            this.$router.push({ query: Object.assign({}, this.$route.query, routeQuery) }).catch(() => {})

                            if (this.formData.msisdn !== '') await this.getMonitorProviders()
                            this.loading = false
                        } else {
                            this.formData.carrier = user.carrierId.carrierId
                            await this.getProviders()

                            if (this.formData.msisdn) await this.getMonitorProviders()
                            this.loading = false
                        }
                    }

                    if (user.providerId) {
                        this.showProviderSelect = false
                        this.formData.provider.push(user.providerId.providerId)
                    }
                } else {
                    if (this.formData.msisdn) await this.getMonitorProviders()
                    this.loading = false
                }
            })
    }

    getMonitorProviders () {
        return new Promise(resolve => {
            if (!Array.isArray(this.formData.provider)) this.formData.provider = [this.formData.provider]
            const user = JSON.parse(JSON.stringify(this.userData))
            const provider = user.providerId ? [user.providerId.providerId] : this.formData.provider

            this.$store.dispatch('getMonitorProviders', { outgoingMsisdn: this.formData.msisdn, providerId: provider, carrierId: this.formData.carrier })
                .then(resp => {
                    if (resp?.status === 200) {
                        this.tabs = []

                        // Every provider comes back as a tab now, so an empty
                        // response no longer signals "nothing found". The alert
                        // fires when the line holds no subscription anywhere.
                        // Assigned, not latched: a successful search after a
                        // failed one used to leave the alert stuck on screen.
                        this.notFoundProviderFlag =
                            resp.data.length === 0 ||
                            resp.data.every(
                                (p: { subscription_state: string }) =>
                                    (p.subscription_state || 'none') === 'none'
                            )

                        resp.data.forEach((p: {
                            provider_name: string|null;
                            provider_id: number|null;
                            carrier_name: string|null;
                            subscription_state: 'active'|'cancelled'|'none';
                        }) => {
                            this.tabs.push({
                                providerName: p.provider_name || p.carrier_name || '',
                                providerId: p.provider_id,
                                // The blacklist fallback row is the only one without a provider.
                                onlyBlacklist: !p.provider_id,
                                state: p.subscription_state || 'none'
                            })
                        })

                        this.$forceUpdate()

                        resolve()
                    } else {
                        // Without this the promise never settles and mounted() awaits
                        // it forever, leaving the screen stuck on the spinner.
                        this.loading = false
                        resolve()
                    }
                })
        })
    }

    async createUrl () {
        await (this.$refs.form as Vue & { validate: () => boolean })

        if (!this.formValid) return

        const msisdn = this.formData.msisdn
        const providerString: string[] = []

        if (this.formData.provider) {
            this.formData.provider.forEach((p: number) => {
                providerString.push(p.toString())
            })
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const query: any = {
            carrier: this.formData.carrier,
            provider: providerString
        }

        this.$router.push({
            name: 'Monitor',
            params: { msisdn },
            query
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        }).catch(() => {
            location.reload()
        })
    }

    getCarriers () {
        return new Promise(resolve => {
            this.$store.dispatch('getMonitorCarriersFilter')
                .then(resp => {
                    if (resp?.status === 200) {
                        this.carriers = resp.data.map((c: APICarrier) => {
                            return {
                                text: c.carrierName,
                                value: c.carrierId
                            }
                        })

                        resolve()
                    }
                })
        })
    }

    getProviders () {
        return new Promise(resolve => {
            this.loadingProviders = true
            this.$store.dispatch('getMonitorProvidersList', this.formData.carrier)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.providers = resp.data.map((p: APIProvider) => {
                            return {
                                text: p.providerName,
                                value: p.providerId,
                                carrierId: p.carrierId
                            }
                        })

                        if (this.$route.query.provider) {
                            if (Array.isArray(this.$route.query.provider)) {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                const providerList: any[] = []
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                this.$route.query.provider.forEach(p => {
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    const providerFound = this.providers.find((provider: any) => p && provider.value === parseInt(p.toString()))

                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    if (providerFound) providerList.push(parseInt((providerFound as any).value));
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    (this.formData as any).provider = providerList
                                })
                            } else {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                let providerFound: any = null
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                providerFound = this.providers.find((provider: any) => provider.value === parseInt(this.$route.query.provider.toString()))
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                if (providerFound) (this.formData as any).provider = [providerFound.value]
                            }
                        }
                        this.loadingProviders = false
                        resolve()
                    } else {
                        this.loadingProviders = false
                        this.loading = false
                        // Without this the promise never settles and every
                        // awaiting caller stays pending forever.
                        resolve()
                    }
                })
        })
    }

    async startBigLoad () {
        this.alreadySearch = true
        this.bigLoadingState = 0

        this.loadTriggers.subscription = !this.loadTriggers.subscription
        this.loadTriggers.presubscription = !this.loadTriggers.presubscription
        this.loadTriggers.blacklist = !this.loadTriggers.blacklist
        this.loadTriggers.notification = !this.loadTriggers.notification
        this.loadTriggers.messages = !this.loadTriggers.messages
    }

    async refreshSection (number: number) {
        switch (number) {
        case 1:
            this.loadTriggers.subscription = !this.loadTriggers.subscription
            break
        case 2:
            this.loadTriggers.subscriptionHistory = !this.loadTriggers.subscriptionHistory
            break
        case 3:
            this.loadTriggers.presubscription = !this.loadTriggers.presubscription
            break
        case 4:
            this.loadTriggers.blacklist = !this.loadTriggers.blacklist
            break
        case 5:
            this.loadTriggers.messages = !this.loadTriggers.messages
            break
        case 6:
            this.loadTriggers.notification = !this.loadTriggers.notification
            break
        }
    }

    getDateFormat (dateString: string) {
        if (!dateString) return '-'
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
